import type { CustomIconProps } from '../CustomIcon';

export const UserIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  unfilled,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}>
      <path
        d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'
        fill={unfilled ? 'none' : color}
        stroke={color}
      />
      <path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' stroke={secondaryColor} />
      <path
        d='M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z'
        fill={unfilled ? 'none' : color}
        stroke={color}
      />
    </svg>
  );
};
